import useLocales from 'hooks/useLocales';
import React, { FC } from 'react';
import PageHeader from 'components/PageHeader';
import LanguageToggle from 'components/LanguageToggle';

export const ActivateAccount: FC = (): JSX.Element => {
  const { t } = useLocales();
  return (
    <>
      <PageHeader showLanguageSelector={false} />
      <h1>{t('Please activate account')}</h1>
      <LanguageToggle />
    </>
  );
};
